import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Inscription } from 'src/app/interfaces/inscription';
import { InscriptionService } from 'src/app/services/inscription.service';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from 'src/app/services/error.service';

//fk
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/interfaces/user';

import { StudentService } from 'src/app/services/student.service';
import { CareerService } from 'src/app/services/career.service';
import { Career } from 'src/app/interfaces/career';
import { Student } from 'src/app/interfaces/student';

@Component({
  selector: 'app-add-edit-inscription',
  templateUrl: './add-edit-inscription.component.html',
  styleUrls: ['./add-edit-inscription.component.css']
})
export class AddEditInscriptionComponent implements OnInit {
  form: FormGroup;
  loading: boolean = false;
  id: number;
  operacion: string = 'Agregar ';
  lastUser: User | null = null;
  idUserInscription: number=0;
  idcareer: number=0;

  careers: Career[] = [];
  students: Student[] = [];
  selectedCareer: Career | null = null;
  selectedStudent: Student | null = null;

  constructor(private fb: FormBuilder,
    private _inscriptionService: InscriptionService,
    private router: Router,
    private toastr: ToastrService,
    private aRouter: ActivatedRoute,
    private _studentService: StudentService,
    private _careerService: CareerService,
    private _errorService: ErrorService
    ) {
    this.form = this.fb.group({
      /*namestudent: ['', Validators.required],
      lastnamestudent: ['', Validators.required],
      ci: ['', Validators.required],
      namecareer: ['', Validators.required],*/
      idstudent: ['', Validators.required],
      idcareer: ['', Validators.required],
    })
    this.id = Number(aRouter.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {
    // Obtener la lista de carreras
    this._careerService.getListCareers().subscribe((careers: Career[]) => {
      this.careers = careers;
    }, (error) => {
      console.error('Error al obtener las carreras:', error);
    });

    // Obtener la lista de estudiantes
    this._studentService.getListStudents().subscribe((students: Student[]) => {
      this.students = students;
    }, (error) => {
      console.error('Error al obtener los estudiantes:', error);
    });
    if (this.id != 0) {
      // Es editar
      this.operacion = 'Editar ';
      this.getInscription(this.id);
    }
  }

  /*getInscription(id: number) {
    this.loading = true;
    this._inscriptionService.getInscription(id).subscribe((data: Inscription) => {
      this.loading = false;
      this.form.setValue({
        name: data.name,
        lastname: data.lastname,
        ci: data.ci,
        email: data.userid
      })
    })
  }*/
  selectCareer(career: Career) {
    this.selectedCareer = career;
    this.form.patchValue({
      idcareer: career.id
    });
  }

  selectStudent(student: Student) {
    this.selectedStudent = student;
    this.form.patchValue({
      idstudent: student.id
    });
  }
  getInscription(id: number) {
    this.loading = true;
    this._inscriptionService.getInscription(id).subscribe((data: Inscription) => {
      this.loading = false;
      //obtener carrera
      if (data.idcareer !== undefined) {
        this._careerService.getCareer(data.idcareer).subscribe((data2: Career) => {
          this.loading = false;
          this.selectedCareer = data2;
          //console.log("valores de Career: "+data2.id);
          this.form.patchValue({
            idcareer: data2.id
          });
        })

        
      } else {
        console.error('El ID de carrera es undefined.');
      }
      //obtener estudiante
      if (data.idcareer !== undefined) {
        //console.log("user.email: "+data.userid)
        this._studentService.getStudent(data.idstudent).subscribe((student: Student) => {
          this.selectedStudent = student;
          //console.log("student.id: "+student.id);
          this.form.patchValue({
            idstudent: student.id
          });
        }, (error) => {
          console.error('Error al obtener la inscripción:', error);
        });
      } else {
        console.error('El ID de estudiante es undefined.');
      }
    });
  }
  
  
  
  addInscription() {
    let inscription: Inscription = {
      idstudent: this.form.value.idstudent,
      idcareer: this.form.value.idcareer,
      namestudent: this.selectedStudent?.name || '',
      lastnamestudent: this.selectedStudent?.lastname || '',
      state: 1
    };

    /*if (!this.isEmail(this.form.value.email)) {
      console.log("Email: " + this.form.value.email);
      this.toastr.error('El campo email campo debe ser un correo electrónico', 'Error');
      return;
    }*/

    /*let pass: string;
    pass = Math.floor(1000 + Math.random() * 9000).toString();
    this.addUserParams(this.form.value.email, pass, 2);*/
    //console.log("valores enviados inscription id student: "+inscription.idstudent+", idcareer: "+inscription.idcareer);
    this.saveOrUpdateInscription(inscription);
    /*
    this._userService.getLastUser().subscribe(
      (user: User) => {
        this.lastUser = user;
        this.idUserInscription = this.lastUser?.id != null ? this.lastUser.id + 1 : 0;
        console.log('Último usuario:', this.lastUser.id);
        inscription.userid = this.idUserInscription; // Actualizamos userid con el valor obtenido
        this.saveOrUpdateInscription(inscription);
      },
      (error) => {
        console.error('Error al obtener el último usuario:', error);
      }
    );*/
}

saveOrUpdateInscription(inscription: Inscription) {
    this.loading = true;

    if (this.id !== 0) {
      // Es editar 
    //  console.log("Editando: " + inscription);
      inscription.id = this.id;
      this._inscriptionService.updateInscription(this.id, inscription).subscribe(() => {
        this.toastr.info(`La inscripción del estudiante: ${inscription.namestudent} fue actualizado con exito`, 'Inscripción actualizada');
        this.loading = false;
        this.router.navigate(['/inscription']);
      });

    } else {
      // Es agregar
     // console.log("Agregando: " + inscription);
      this._inscriptionService.saveInscription(inscription).subscribe(() => {
        this.toastr.success(`El estudiante ${inscription.namestudent} fue inscrito con exito`, 'Inscripción registrada');
        this.loading = false;
        this.router.navigate(['/inscription']);
      });
    }
}
  
  /*addUserParams(email:string, password:string, rol:number) {
    //Validamos que el username sea un correo
    if (!this.isEmail(email)) {
      this.toastr.error('El primer campo debe ser un correo electrónico', 'Error');
      return;
    }
    // Validamos que el usuario ingrese valores
    if (email == '' || password == '') {
      this.toastr.error('Todos los campos son obligatorios', 'Error');
      return;
    }
    // Creamos el objeto
    const user: User = {
      username: email,
      password: password,
      rol: rol
    }
    this.loading = true;
    this._userService.signIn(user).subscribe({
      next: (v) => {
        this.loading = false;
        this.toastr.success(`El usuario ${email} fue registrado con exito`, 'Usuario registrado');
        //this.router.navigate(['/login']);

        // Aquí puedes acceder a los valores del usuario
        const id = v.id;
        const email2 = v.email;
        // Realiza las acciones necesarias con los valores del usuario
        //console.log("Usuario id: "+id+ ", email: "+email2); 
        
      },
      error: (e: HttpErrorResponse) => {
        this.loading = false;
        this._errorService.msjError(e);
      }
    })
    
  }
  generateRandomNumber(): number {
    return Math.floor(1000 + Math.random() * 9000);
  }
  isEmail(email: string): boolean {
    // Expresión regular para validar un correo electrónico
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }*/
}
